/* Meera Capsule — cart page tidy-up (live since 2026-10-17). See assets/meera-cart-page.css.
   Loaded on the cart template from a hidden custom-liquid section in templates/cart.json
   (the guard below stops a second run if it is ever loaded twice).
   - Discount lines read "VIP15 ... −$11 CAD" (name left, amount right) instead of "VIP15 (-$11 CAD)".
   - "Cart total" is hidden when it equals the subtotal (no discount), so the price isn't shown twice.
   - "Save cart" under the Capsule progress bar in the summary panel. It hands off to the cart
     drawer's Save cart button (assets/meera-identify.js), so the save, the sheet and the
     "Saved Cart" event are exactly the same as in the drawer.
   - Empty cart, signed-out visitors: the drawer's sign-up block (box, Sign in with Shop, email
     sign-up, built by assets/meera-identify.js) is moved onto the page in place of the theme's
     "Log in" / "Continue shopping" buttons. Moving the node keeps its behaviour; meera-identify.js
     then builds a fresh one for the drawer. Signed-in customers keep the theme's buttons.
   Re-applies after the theme re-renders the cart section. */
(function () {
  if (window.__meeraCartPage) return;
  window.__meeraCartPage = true;

  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.5 3.5h11v17l-5.5-3.9-5.5 3.9z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';

  function cartSaved() {
    try { return !!window.sessionStorage.getItem('meeraCartSaved'); } catch (e) { return false; }
  }

  function addSaveCart(root) {
    var panel = root.querySelector('.cart-page__block--price');
    if (!panel || panel.querySelector('.meera-save-bag-link')) return;
    var wrap = document.createElement('div');
    wrap.className = 'meera-save-bag-link meera-save-bag-link--page';
    wrap.innerHTML = '<button type="button" class="meera-save-item__trigger" aria-pressed="false">' + ICON + '<span>Save cart</span></button>';
    var btn = wrap.querySelector('button');
    if (cartSaved()) { btn.setAttribute('aria-pressed', 'true'); btn.querySelector('span').textContent = 'Cart saved'; }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.getAttribute('aria-pressed') === 'true') return;
      var drawerBtn = document.querySelector('cart-drawer .meera-save-bag-link button');
      if (drawerBtn) drawerBtn.click();
    });
    var bar = panel.querySelector('.capsule-builder-bar');
    if (bar) bar.appendChild(wrap);
    else panel.insertBefore(wrap, panel.firstChild);
  }

  function adoptEmptySignup(root) {
    var actions = root.querySelector('.cart-page__empty-actions');
    if (!actions || root.querySelector('.meera-cart-signup')) return;
    var box = document.querySelector('cart-drawer .meera-cart-signup');
    if (!box) return;
    actions.insertAdjacentElement('beforebegin', box);
  }

  function tidy(root) {
    root.querySelectorAll('.discounts__discount--position').forEach(function (li) {
      if (li.querySelector('.meera-disc-amt')) return;
      var nodes = Array.prototype.filter.call(li.childNodes, function (n) {
        return n.nodeType === 3 && n.textContent.trim();
      });
      var text = nodes.map(function (n) { return n.textContent; }).join(' ').replace(/\s+/g, ' ').trim();
      var m = text.match(/^(.*?)\s*\(\s*-\s*(.+?)\s*\)$/);
      if (!m) return;
      nodes.forEach(function (n) { n.parentNode.removeChild(n); });
      var name = document.createElement('span');
      name.className = 'meera-disc-name';
      name.textContent = m[1];
      var amt = document.createElement('span');
      amt.className = 'meera-disc-amt';
      amt.textContent = '−' + m[2];
      li.appendChild(name);
      li.appendChild(amt);
    });

    var total = root.querySelector('.cart-totals');
    var totalValue = root.querySelector('.cart-totals__value');
    var subtotal = root.querySelector('.totals__subtotal-value');
    if (total && totalValue && subtotal) {
      var same = totalValue.textContent.trim() === subtotal.textContent.trim();
      if (total.hidden !== same) total.hidden = same;
    }

    addSaveCart(root);
    adoptEmptySignup(root);
  }

  function start() {
    var root = document.getElementById('main-cart');
    if (!root) return;
    tidy(root);
    // Whole document: the drawer's sign-up block is built after this runs.
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; tidy(root); }, 50);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
